import styled from 'styled-components';
import Sider from 'antd/lib/layout/Sider';

export const LeftPanelStyled = styled(Sider)`
  .ant-layout-sider-children {
    position: fixed;
    width: ${({ collapsed }) => collapsed ? 70 : 220}px;
    height: calc(100vh - 48px);
    transition: all .2s;
  }

  .ant-layout-sider-trigger {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 23px;

    svg {
      transform: rotate(${({ collapsed }) => collapsed ? 180 : 0}deg);
      transition: all .2s;
    }

    &:hover {
      svg {
        color: ${({ theme }) => theme.colorWarning};
      }
    }
  }
`;

export const LeftPanelMenuItemStyled = styled.div
  .attrs({
    className: 'relative px-3 duration-300 whitespace-nowrap cursor-pointer '
      + 'before:absolute before:left-0 before:w-0 before:h-full before:bg-orange-50 before:duration-300 '
      + 'before:content-[\'\'] before:rounded-r hover:text-orange-50',
  })<{ isCollapsedLeftPanel: boolean }>`

  :has(.active),
  :hover {
    padding-left: ${({ isCollapsedLeftPanel }) => isCollapsedLeftPanel ? 13 : 21}px;

    &:before {
      width: 8px;
    }
  }

  :has(.active) a {
    color: ${({ theme }) => theme.colorWarning};
  }
`;

export const leftPanelMenuClasses = 'flex flex-col justify-between h-[calc(100vh-135px)] overflow-y-auto '
  + 'overflow-x-hidden mt-5 border-b border-blue-70 dark:border-black-60';
